import { snakeCaseToFirstLetterUpperCase } from "../../../../utils";
import AlertDashboardFilters from "./AlertDashboardFilters";
import {
  ALERT_CATEGORIES,
  availableConstantAlertFilters,
  SearchMetadata,
  SEARCH_METADATA_CATEGORIES,
} from "./utils/constants";
import { TypeaheadComparatorClusterOption } from "@merge-api/merge-javascript-shared/dist/designSystem/molecules/Typeahead/types/types";
import { constructCategorySpecificAlertFilters } from "./utils/helpers";
import { Dispatch, SetStateAction, useMemo } from "react";

interface AlertDashboardHeaderProps {
  category: ALERT_CATEGORIES;
  searchFilters: TypeaheadComparatorClusterOption[];
  setSearchFilters: (filters: TypeaheadComparatorClusterOption[]) => void;
  showResolved: boolean;
  setShowResolved: Dispatch<SetStateAction<boolean>>;
  showSilenced: boolean;
  setShowSilenced: Dispatch<SetStateAction<boolean>>;
  searchMetadata: Record<SEARCH_METADATA_CATEGORIES, SearchMetadata[]>;
}

const AlertDashboardHeader = ({
  category,
  searchFilters,
  setSearchFilters,
  showResolved,
  setShowResolved,
  showSilenced,
  setShowSilenced,
  searchMetadata,
}: AlertDashboardHeaderProps) => {
  const availableSearchFilters = useMemo(() => {
    return [
      ...constructCategorySpecificAlertFilters(category, searchMetadata),
      ...availableConstantAlertFilters,
    ];
  }, [category, searchMetadata]);
  return (
    <>
      <div className="my-4 bg-gray-10 h-[0.5px]" />
      <h3 className="mt-10">{snakeCaseToFirstLetterUpperCase(category)}</h3>
      <br />
      <AlertDashboardFilters
        activeFilters={searchFilters}
        setActiveFilters={setSearchFilters}
        availableFilters={availableSearchFilters}
        showResolved={showResolved}
        setShowResolved={setShowResolved}
        showSilenced={showSilenced}
        setShowSilenced={setShowSilenced}
      />
      <br />
    </>
  );
};

export default AlertDashboardHeader;
